// extracted by mini-css-extract-plugin
module.exports = {"warningClass":"_1Ddx8W1nWo0OU5hM1N6AJi","login-form":"_3S-nSm7in1BuipU3JmaQH_","login-form-forgot":"_3FTSXLlaAZ2BRE8Psk-88i","forgot-password":"_2zUlq1NKXOtd2O6-e85WjL"};